import React from 'react'
import { FaPlus } from 'react-icons/fa'
import ChannelItem from './ChannelItem'

const ChannelSection = ({
  title,
  channels = [],
  isDm = false,
  readReceipts = [],
  onSelectChannel,
  setReadReceipts,
  readReceiptsRef,
  showAddButton = false,
  onAddClick,
  userAvatars = []
}) => (
  <>
    <div className="channel-list-title-row">
      <h4 className="channel-list-title">{title}</h4>
      {showAddButton && (
        <FaPlus
          className="dm-plus-icon"
          style={{ cursor: 'pointer', marginTop: 8, display: 'none' }}
          onClick={onAddClick}
          title="Start new message"
        />
      )}
    </div>
    <div className="channel-scroll-area">
      {channels.map(channel => {
        const receipt = readReceipts?.find?.(r => r?.rid === channel?._id)
        const unreadCount = receipt?.unread || 0
        return (
          <ChannelItem
            key={channel?._id}
            channel={channel}
            unreadCount={unreadCount}
            onSelect={onSelectChannel}
            isDm={isDm}
            readReceipts={readReceipts}
            setReadReceipts={setReadReceipts}
            readReceiptsRef={readReceiptsRef}
            userAvatars={userAvatars}
          />
        )
      })}
    </div>
  </>
)

export default ChannelSection
